import { render, staticRenderFns } from "./CreaNota.vue?vue&type=template&id=2644887e"
import script from "./CreaNota.vue?vue&type=script&lang=js"
export * from "./CreaNota.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports